import { useState, useEffect } from "react";
import AppHeader from "./components/AppHeader";
import StoriesRow from "./components/StoriesRow";
import MainCards from "./components/MainCards";
import CategoryPills from "./components/CategoryPills";
import ContentCarousel from "./components/ContentCarousel";
import JobsSection from "./components/JobsSection";
import RegistrationModal from "./components/RegistrationModal";
import WhatsAppButton from "./components/WhatsAppButton";
import WazeButton from "./components/WazeButton";
import AccessibilityButton from "./components/AccessibilityButton";
import ScrollToTopButton from "./components/ScrollToTopButton";
import LocationsGrid from "./components/LocationsGrid";
import PartnersSlider from "./components/PartnersSlider";
import { activityService } from "@/services/activity.service";
import { jobService } from "@/services/job.service";
import { publicApi } from "../../services/api";
import partnerLogo from "../../assets/partner.png";
type ActivityItem = {
  id: number;
  title: string;
  image: string;
  tag: string;
  tagColor: string;
  meta1?: string;
  meta2?: string;
  detailId: string;
};

export default function HomePage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [regType, setRegType] = useState("Activity");
  const [regId, setRegId] = useState<number | null>(null);
  const [webinarCards, setWebinarCards] = useState<ActivityItem[]>([]);
  const [trainingCards, setTrainingCards] = useState<ActivityItem[]>([]);
  const [workshopCards, setWorkshopCards] = useState<ActivityItem[]>([]);
  const [jobsData, setJobsData] = useState<any[]>([]);
  const [sitePhone, setSitePhone] = useState("");
  const [siteWazeUrl, setSiteWazeUrl] = useState("");
  const [activitiesLoading, setActivitiesLoading] = useState(true);

  useEffect(() => {
    activityService
      .list()
      .then((activities) => {
        const webinars = activities.filter(
          (a) => a.type?.name === "webinar" || a.activity_type_id === 1,
        );
        const trainings = activities.filter(
          (a) => a.type?.name === "training" || a.activity_type_id === 3,
        );
        const workshops = activities.filter(
          (a) => a.type?.name === "workshop" || a.activity_type_id === 2,
        );

        setWebinarCards(
          webinars.map((w) => ({
            id: w.id,
            title: w.title,
            image: w.image || "",
            tag: "חינמי",
            tagColor: "#6EE7B7",
            meta1: w.time ? `${w.date} · ${w.time}` : w.date,
            meta2: w.location,
            detailId: `activity-${w.id}`,
          })),
        );

        setTrainingCards(
          trainings.map((t) => ({
            id: t.id,
            title: t.title,
            image: t.image || "",
            tag: "פופולרי",
            tagColor: "#FCA5A5",
            meta1: t.time ? `${t.date} · ${t.time}` : t.date,
            meta2: t.location,
            detailId: `activity-${t.id}`,
          })),
        );

        setWorkshopCards(
          workshops.map((w) => ({
            id: w.id,
            title: w.title,
            image: w.image || "",
            tag: "חדש",
            tagColor: "#A78BFA",
            meta1: w.time ? `${w.date} · ${w.time}` : w.date,
            meta2: w.location,
            detailId: `activity-${w.id}`,
          })),
        );
      })
      .catch(() => {})
      .finally(() => setActivitiesLoading(false));

    jobService
      .list()
      .then((jobs) => setJobsData(jobs))
      .catch(() => {});
    publicApi
      .get("/settings/public")
      .then(({ data }) => {
        setSitePhone(data.site_phone || "");
        setSiteWazeUrl(data.linkedin_url || "");
      })
      .catch(() => {});
  }, []);

  return (
    <div
      className="min-h-screen pb-8"
      style={{ background: "#FAF9F6", direction: "rtl" }}
      dir="rtl"
    >
      <AppHeader onSearchClick={() => setModalOpen(true)} />

      <div className="px-4 pt-4 pb-1" dir="rtl">
        <p className="text-sm text-gray-500 font-medium">שלום, ברוך הבא 👋</p>
        <h1 className="text-2xl font-black text-gray-900 leading-tight">
          מה נעשה היום?
        </h1>
      </div>

      <StoriesRow />

      <div id="scroll-pills">
        <CategoryPills />
      </div>

      <div id="main-cards">
        <MainCards onRegisterClick={() => setModalOpen(true)} />
      </div>
      <div className="flex flex-col items-center px-4 pt-4 pb-2" dir="rtl">
        <p className="text-xs font-semibold text-gray-400 tracking-widest uppercase mb-2">
          בשיתוף
        </p>
        <div
          className="flex items-center justify-center rounded-2xl border border-gray-200 px-8 py-4"
          style={{ background: "#F5F3EE", minWidth: 260, maxWidth: 360 }}
        >
          <img
            src={partnerLogo}
            alt="לוגו שותף"
            className="object-contain"
            style={{ maxHeight: 160, maxWidth: 320, width: "100%" }}
          />
        </div>
      </div>
      <div id="webinars">
        {(activitiesLoading || webinarCards.length > 0) && (
          <ContentCarousel
            title="וובינרים קרובים"
            icon="ri-live-line"
            accentColor="#EDE9FE"
            cards={webinarCards}
            ctaLabel="הרשמה לוובינר"
            loading={activitiesLoading}
            onCtaClick={(id) => {
              setRegId(id);
              setRegType("Activity");
              setModalOpen(true);
            }}
            typeName="webinar"
          />
        )}
      </div>

      {/* <div id="trainings">
        {trainingCards.length > 0 && (
          <ContentCarousel
            title="הכשרות מקצועיות"
            icon="ri-graduation-cap-line"
            accentColor="#FEF9C3"
            cards={trainingCards}
            ctaLabel="הרשמה להכשרה"
            onCtaClick={(id) => {
              setRegId(id);
              setRegType("Activity");
              setModalOpen(true);
            }}
            typeName="training"
          />
        )}
      </div> */}

      <div id="workshops">
        {(activitiesLoading || workshopCards.length > 0) && (
          <ContentCarousel
            title="סדנאות"
            icon="ri-tools-line"
            accentColor="#FEE2E2"
            cards={workshopCards}
            ctaLabel="הרשמה לסדנה"
            loading={activitiesLoading}
            onCtaClick={(id) => {
              setRegId(id);
              setRegType("Activity");
              setModalOpen(true);
            }}
            typeName="workshop"
          />
        )}
      </div>
      <div id="jobs">
        <JobsSection
          jobs={jobsData}
          onApplyClick={(id) => {
            setRegId(id);
            setRegType("Job");
            setModalOpen(true);
          }}
        />
      </div>
      <LocationsGrid />

      <section className="mx-4 my-4" dir="rtl">
        <div
          className="rounded-3xl border-[3px] border-gray-900 overflow-hidden"
          style={{ background: "#FFFFFF" }}
        >
          <div className="h-2 w-full" style={{ background: "#EDE9FE" }}></div>
          <div className="p-5">
            <div className="flex justify-center mb-4">
              <span
                className="flex items-center gap-2 rounded-full border-[2px] border-gray-900 px-4 py-1.5 text-xs font-black"
                style={{ background: "#FDE68A" }}
              >
                <i className="ri-play-circle-fill text-gray-900 text-sm"></i>{" "}
                סיפור הצלחה אמיתי
              </span>
            </div>
            <h2 className="text-xl font-black text-gray-900 text-center leading-snug mb-5">
              כשנותנים הזדמנות —{" "}
              <span
                className="relative inline-block"
                style={{ color: "#7C3AED" }}
              >
                החיים משתנים
              </span>
            </h2>
            <div
              className="rounded-2xl border-[2.5px] border-gray-900 overflow-hidden w-full"
              style={{ aspectRatio: "16/9" }}
            >
              <iframe
                src="https://www.youtube.com/embed/4x06nH7F01k?rel=0&modestbranding=1"
                title="סיפור הצלחה - מתר"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
                style={{ border: "none", display: "block" }}
              ></iframe>
            </div>
            <p className="text-sm font-semibold text-gray-500 text-center mt-4 leading-relaxed">
              ליווי נכון יכול לשנות מסלול חיים
            </p>
            <button
              onClick={() => setModalOpen(true)}
              className="mt-4 w-full flex items-center justify-center gap-2 bg-gray-900 text-white rounded-2xl py-3.5 text-base font-black border-2 border-gray-900 hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line text-base"></i> גם אני רוצה
              להתחיל
            </button>
          </div>
        </div>
      </section>

      <PartnersSlider />
      <WhatsAppButton phone={sitePhone} />
      <AccessibilityButton />
      <ScrollToTopButton />
      <WazeButton url={siteWazeUrl} />

      <RegistrationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        registerableType={regType}
        registerableId={regId ?? undefined}
      />
    </div>
  );
}
